export const CHORD_KINDS = {
  ALPHABET: "ALPHABET",
  DEGREE: "DEGREE",
};

export type ChordKindType = (typeof CHORD_KINDS)[keyof typeof CHORD_KINDS];

export const SHARP_NOTES = {
  A: "A",
  "A#": "A#",
  B: "B",
  C: "C",
  "C#": "C#",
  D: "D",
  "D#": "D#",
  E: "E",
  F: "F",
  "F#": "F#",
  G: "G",
  "G#": "G#",
};
export type SharpNoteType = (typeof SHARP_NOTES)[keyof typeof SHARP_NOTES];
export const sharpNotes = [
  "A",
  "A#",
  "B",
  "C",
  "C#",
  "D",
  "D#",
  "E",
  "F",
  "F#",
  "G",
  "G#",
];
export const SIGNATURES = {
  SHARP: "SHARP",
  FLAT: "FLAT",
};
export type SignatureType = (typeof SIGNATURES)[keyof typeof SIGNATURES];
export const KEY_SIGNATURES: { [key: string]: SignatureType } = {
  A: SIGNATURES.SHARP,
  Bb: SIGNATURES.FLAT,
  B: SIGNATURES.SHARP,
  C: SIGNATURES.SHARP,
  Db: SIGNATURES.FLAT,
  D: SIGNATURES.SHARP,
  Eb: SIGNATURES.FLAT,
  E: SIGNATURES.SHARP,
  F: SIGNATURES.FLAT,
  Gb: SIGNATURES.FLAT,
  G: SIGNATURES.SHARP,
  Ab: SIGNATURES.FLAT,
};
export const FLAT_NOTES = {
  A: "A",
  Bb: "Bb",
  B: "B",
  C: "C",
  Db: "Db",
  D: "D",
  Eb: "Eb",
  E: "E",
  F: "F",
  Gb: "Gb",
  G: "G",
  Ab: "Ab",
};
export type FlatNoteType = (typeof FLAT_NOTES)[keyof typeof FLAT_NOTES];
export const flatNotes = [
  "A",
  "Bb",
  "B",
  "C",
  "Db",
  "D",
  "Eb",
  "E",
  "F",
  "Gb",
  "G",
  "Ab",
];
export const degreeToIndex: { [key: string]: number } = {
  "1": 0,
  "1#": 1,
  "2b": 1,
  "2": 2,
  "2#": 3,
  "3b": 3,
  "3": 4,
  "4": 5,
  "4#": 6,
  "5b": 6,
  "5": 7,
  "5#": 8,
  "6b": 8,
  "6": 9,
  "6#": 10,
  "7b": 10,
  "7": 11,
};
export const FLAT_DEGREES = [
  "1",
  "2b",
  "2",
  "3b",
  "3",
  "4",
  "5b",
  "5",
  "6b",
  "6",
  "7b",
  "7",
];

export const KIND_QUERY_PARAMS = "kind";

export const DEGREES = new Map([
  ["1", "Ⅰ"],
  ["1#", "#Ⅰ"],
  ["2b", "♭Ⅱ"],
  ["2", "Ⅱ"],
  ["2#", "#Ⅱ"],
  ["3b", "♭Ⅲ"],
  ["3", "Ⅲ"],
  ["4", "Ⅳ"],
  ["4#", "#Ⅳ"],
  ["5b", "♭Ⅴ"],
  ["5", "Ⅴ"],
  ["5#", "#Ⅴ"],
  ["6b", "♭Ⅵ"],
  ["6", "Ⅵ"],
  ["6#", "#Ⅵ"],
  ["7b", "♭Ⅶ"],
  ["7", "Ⅶ"],
]);

export const QUALITIES = [
  "m",
  "m7",
  "7",
  "7-5",
  "M7",
  "mM7",
  "m7-5",
  "dim7",
  "aug",
  "sus4",
  "7sus4",
  "6",
  "m6",
  "add9",
  "9",
  "7#9",
  "m9",
  "omit3",
];

export type ChordKeyType = "base" | "quality" | "onBase";

export const EXISTED_GUITAR_CHORDS = [
  "", // major
  "_m",
  "_m7",
  "_7",
  "_7-5",
  "_Maj7",
  "_mM7",
  "_m7-5",
  "_dim7",
  "_aug",
  "_sus4",
  "_sus4_on3", // Dsus4 on F#
  "_7sus4",
  "_6",
  "_m6",
  "_add9",
  "_9",
  "_7s9",
  "_7-9",
  "_m9",
  "_omit3",
  // major on X
  "_on2", // 4 on 5
  "_on3", // 1 on 3, 5 on 7
  "_on4", // 1 on 4
  "_on5b", // 1 on 5b
  "_on5", // 1 on 5
  "_on7b", // 1 on 7b, 5 on 4
  "_on7", // 1 on 7
  // minor on X
  "_m_on2", // 4m on 5
  "_m_on3b", // 4m on 6b
  "_m_on5", // 4m on 1
  "_m_on7", // 6m on 6b
  "_m_on7b", // 6m on 5
  // m7 on X
  "_m7_on4", // 2m7 on 5
  // aug on X
  "_aug_on5b", // 1aug on 4#
];

export const mainURL = "https://music-chord.com/";
